import { useEffect, useMemo, useState } from "react";
import StorageStateKeys from "../../../state";
import { useAtom } from "jotai";
import { QueryAtom } from "../../../services/queries";
import CpdCaseListPage from "./cases";
import CpdConditionListPage from ".";
import CpdCourseListPage from "./course.list";

const CMSPageResourceList = ({
  pathname,
  loading,
  toolbarLandingLabel,
  resource,
  storageStateKey,
  onDelete,
}) => {
  const [queryParams, setQueryParams] = useState({
    // orJunction: true,
    // title: "",
    // themeTitle: "",
    // scenario: "",
    size: 1000,
    page: 0,
    includeDeleted: false,
    includeAllProps: true,
    includeNodes: true,
    status: "ALL",
  });

  const [resources, setResources] = useAtom(StorageStateKeys[resource]["ALL"], {
    delay: 0,
  });
  const [{ data: resourcesData, isLoading, isPending, refetch }] = useAtom(
    useMemo(
      () => QueryAtom[resource]?.getAll(queryParams),
      [resource, queryParams]
    ),
    {
      delay: 0,
      refetchOnWindowFocus: true,
    }
  );

  useEffect(() => {
    if (resourcesData) {
      setResources(resourcesData);
    }
  }, [resourcesData, setResources, queryParams]);

  switch (resource) {
    case "cases":
      return (
        <CpdCaseListPage
          loading={loading || isLoading || isPending}
          listItems={resources}
          refetch={refetch}
          setQueryParamFilter={setQueryParams}
        />
      );
    case "guidelines":
    case "conditions":
      return (
        <CpdConditionListPage
          loading={loading || isLoading || isPending}
          listItems={resources}
          refetch={refetch}
        />
      );

    case "courses":
      return (
        <CpdCourseListPage
          loading={loading || isLoading || isPending}
          listItems={resources}
          refetch={refetch}
        />
      );
    default:
      return <div>Resource Not Implemented</div>;
  }
};

export default CMSPageResourceList;
